// add player
export function updatePlayersSent(value) {
  return {
    type: 'UPDATE_PLAYER_SENT',
    value
  }
}

export function updatePicksSent(value) {
  return {
    type: 'UPDATE_PICK_SENT',
    value
  }
}

export function updatePicksRec(value) {
  return {
    type: 'UPDATE_PICK_REC',
    value
  }
}

export function updatePlayersRec(value) {
  return {
    type: 'UPDATE_PLAYER_REC',
    value
  }
}

export function updatePicksKept(value) {
  return {
    type: 'UPDATE_PICKS_KEPT',
    value
  }
}

export function updateLeagueSize(value) {
  return {
    type: 'UPDATE_LEAGUE_SIZE',
    value
  }
}




// WEBPACK FOOTER //
// ./src/actions/actionCreators.js